import request from "@/utils/request";

// 读取配置
export function configload(params) {
  return request({
    url: "/admin/system/config/load",
    method: "get",
    params,
  });
}

// 保存配置
export function configsave(data) {
  return request({
    url: "/admin/system/config/save",
    method: "post",
    data,
  });
}